import * as React from 'react'
import { BPMChart } from '../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../api'
import { ArgumentAxis, Label, TickInterval, SeriesTemplate, CommonSeriesSettings, Legend, Series } from 'devextreme-react/chart'
import { GroupByDate, GroupByDateType } from '../../../components/GroupByDate'
import { resultDateTransformer } from '../../../utils/date'
import { GroupByType } from '../../../components/GroupByType'
import { defaultGroupTypes } from 'components/grouping/views'

export const DownloadChart: React.FunctionComponent<{}> = () => {

    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')
    const [groupBy, setGroupBy] = React.useState<string | undefined>('membership')

    const toolbarItems = GroupByType(defaultGroupTypes, groupBy, (selected) => {
        setGroupBy(selected)
    }).concat(GroupByDate(groupDateBy, (selected) => {
        setGroupDateBy(selected)
    }))
    return (
        <BPMChart title='Downloads' subTitle={groupBy ? `By ${groupBy.slice(0, 1).toUpperCase()}${groupBy.slice(1)}` : 'Total'} type='bar'
            additionalParams={{ groupDateBy, groupBy }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('downloads', options, signal))
            }} toolBarItems={() => toolbarItems}>
            <SeriesTemplate
                nameField={groupBy}
            />
            {!groupBy && <Series name='Downloads' />}
            <CommonSeriesSettings type='bar'
                valueField="count"
                argumentField="date">
            </CommonSeriesSettings>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined}
                    weeks={groupDateBy == 'week' ? 1 : undefined}
                    months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>

            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/charts/DownloadChart.tsx